export default __webpack_public_path__ + "static/media/circle-exit-white.0e4c2e7c.svg";